<div class="main-toolbar mat-elevation-z2 top-page-controls">
  <div class="title-place" i18n>
    {{ 'sources.details.Title' | translate:{slug: source.Slug} }}
  </div>
  <div class="button-controls">
    <div class="card-top-buttons">
      <button mat-button color="primary" (click)="goBack()">
        <mat-icon>undo</mat-icon>
        {{ 'system.back' | translate }}
      </button>
      <button mat-raised-button color="warn" (click)="actionRemove($event)" *ngIf="!source.IsArchived">
        <mat-icon>archive</mat-icon>
        {{'system.archive' | translate }}
      </button>
      <button mat-raised-button color="warn" (click)="actionRestore()" *ngIf="source.IsArchived">
        <mat-icon>unarchive</mat-icon>
        {{'system.restore' | translate }}
      </button>
      <button mat-raised-button color="primary" (click)="openMappingForm()">
        <mat-icon>settings_ethernet</mat-icon>
        {{'system.mapping' | translate }}
      </button>
      <button mat-raised-button color="success" (click)="openEditForm()">
        <mat-icon>mode_edit</mat-icon>
        {{'system.edit' | translate }}
      </button>
    </div>
  </div>
</div>
<mat-card class="table-place">
  <mat-card-content>

    <table class="source-view-table table table-condensed">
      <tbody>
      <tr>
        <td>{{ 'sources.details.Id' | translate }}</td>
        <td>{{ source.Id }}</td>
      </tr>
      <tr>
        <td>{{ 'sources.details.Slug' | translate }}</td>
        <td>{{ source.Slug }}</td>
      </tr>
      <tr *ngIf="identityService.isSuperAdmin()">
        <td>{{ 'sources.details.CompanySlug' | translate }}</td>
        <td>{{ source.CompanySlug }}</td>
      </tr>
      <tr>
        <td>{{ 'sources.details.Type' | translate }}</td>
        <td>{{ 'sources.details.' + source.Type | translate }}</td>
      </tr>


      <tr *ngIf="isKmlType()">
        <td>{{ 'sources.details.MapUrl' | translate }}</td>
        <td><a href="{{ source.MapUrl }}">{{ source.MapUrl }}</a></td>
      </tr>


      <tr *ngIf="isArcGisType()">
        <td>{{ 'sources.details.Security' | translate }}</td>
        <td>{{ arcGisSecurityTypes[source.Security] }}</td>
      </tr>

      <tr *ngIf="isArcGisType()">
        <td>{{ 'sources.details.FeatureServiceUrl' | translate }}</td>
        <td>{{ source.FeatureServiceUrl }}</td>
      </tr>

      <tr *ngIf="isArcGisType()">
        <td>{{ 'sources.details.IsArcGisOnline' | translate }}</td>
        <td>{{ source.IsArcGisOnline }}</td>
      </tr>

      <tr *ngIf="isArcGisType()">
        <td>{{ 'sources.details.IsRealTime' | translate }}</td>
        <td>{{ source.IsRealTime }}</td>
      </tr>

      <ng-container *ngIf="isArcGisPassword()">
        <tr>
          <td>{{ 'sources.details.AuthenticationUrl' | translate }}</td>
          <td>{{ source.AuthenticationUrl }}</td>
        </tr>
        <tr>
          <td>{{ 'sources.details.Username' | translate }}</td>
          <td>{{ source.Username }}</td>
        </tr>
        <tr>
          <td>{{ 'sources.details.Password' | translate }}</td>
          <td>******</td>
        </tr>
      </ng-container>

      <ng-container *ngIf="isArcGisNtlm()">
        <tr>
          <td>{{ 'sources.details.Username' | translate }}</td>
          <td>{{ source.Username }}</td>
        </tr>
        <tr>
          <td>{{ 'sources.details.Password' | translate }}</td>
          <td>******</td>
        </tr>
      </ng-container>

      <tr *ngIf="isArcGisToken()">
        <td>{{ 'sources.details.Token' | translate }}</td>
        <td>******</td>
      </tr>

      <tr>
        <td>{{ 'sources.details.Description' | translate }}</td>
        <td>{{ source.Description }}</td>
      </tr>
      <tr>
        <td>{{ 'sources.details.MapParsingRules' | translate }}</td>
        <td>
          <pre>{{ source.MapParsingRules }}</pre>
        </td>
      </tr>
      </tbody>
    </table>
  </mat-card-content>
</mat-card>
